import { render, staticRenderFns } from "./StrategyGuide.vue?vue&type=template&id=436f5b64&scoped=true"
import script from "./StrategyGuide.vue?vue&type=script&lang=ts"
export * from "./StrategyGuide.vue?vue&type=script&lang=ts"
import style0 from "./StrategyGuide.vue?vue&type=style&index=0&id=436f5b64&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436f5b64",
  null
  
)

export default component.exports